import React from "react";
import rehabilitarteLogoImg from "../content/rehabilitartelogo.png";
import {bar, rehabilitarteLogo} from "../styles/bar.module.css";
import {Row, Col} from "react-bootstrap";


export function Bar() {
    return <Row className={bar}>
	<Col>
	<span>Un proyecto de</span>
	<img src={rehabilitarteLogoImg} alt="Logo Rehabilitarte" className={rehabilitarteLogo}/>
	</Col>
	
	</Row>;
}
